import { render, staticRenderFns } from "./tab-primary.vue?vue&type=template&id=46689c8e&scoped=true&"
import script from "./tab-primary.vue?vue&type=script&lang=js&"
export * from "./tab-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46689c8e",
  null
  
)

export default component.exports